export const departments = [
    { value: "eye-care", label: "Eye Care" },
    { value: "gynecologist", label: "Gynecologist" },
    { value: "psychotherapist", label: "Psychotherapist" },
    { value: "orthopedic", label: "Orthopedic" },
    { value: "dentist", label: "Dentist" },
    { value: "gastrologist", label: "Gastrologist" },
    { value: "urologist", label: "Urologist" },
    { value: "neurologist", label: "Neurologist" },
];

export const gender = [
    {
        label: "Male",
        value: "male",
    },
    {
        label: "Female",
        value: "female",
    },
    {
        label: "Other",
        value: "other",
    },
];
